import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import BuyingGuidePage from "../pages/buying-guide/page";
import ShippingGuidePage from "../pages/shipping-guide/page";
import QCGuidePage from "../pages/qc-guide/page";
import BrandsPage from "../pages/brands/page";
import SafetyPage from "../pages/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-buying-guide",
    element: <BuyingGuidePage />,
  },
  {
    path: "/cssbuy-spreadsheet-shipping-guide",
    element: <ShippingGuidePage />,
  },
  {
    path: "/cssbuy-spreadsheet-qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/cssbuy-spreadsheet-brands",
    element: <BrandsPage />,
  },
  {
    path: "/cssbuy-spreadsheet-safety",
    element: <SafetyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;